import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../../../http.service';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { Router } from  '@angular/router';
import { ShareddataService } from '../../../shareddata.service';
import { NotificationService } from '../../../notification.service';
import { NgEventBus } from 'ng-event-bus';

declare var $: any;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css'],
  providers: [DatePipe]

})
export class CheckoutComponent implements OnInit {
    user_detail : any =[]; 

	checkOutForm: FormGroup;
	tip_amount : any='';	
	selected_tip_percentage : any='';
	isSubmitted  =  false;
	deliveryamount: any = 0
	showCompleteOrderButton: any = 0
	payment_via: any = 'creditcard'

	showGiftCardLink:any='0';
	checkOutSpin:any=0;
	checkOutData : any =[];
	cartTotalBalance : any =0.00;
	selectedFrancais: any =0;
	francaisData : any =[];
	francaisTax : any =[];
	grandTotalwithTax:any=0.00;
	grandTotalwithTaxTemp: any = 0
	discountAmount: any = 0
	enable_factor4: any ='0'
	loyalityrewardamount: any ='0'
	giftcard_amount: any ='0'

	is_surcharge_enabled='0';
	surcharge_amount='';
	surcharge_label='';
	serverCalucation:any='0';
	
	monthDropDownValues : any =[];
	yearDropDownValues : any =[];
	mytime: any = new Date();
	thisYear : any = this.datePipe.transform(this.mytime, 'YY');
	payment_id:any;
	cardErrorApiCall:any ='';
	bookOrderApiMessage : any ='';
	bookOrderResponse :any =[]; 
	selectedFrancaisData :any =[]; 
	deliveryAddressSaved :any =[]; 
	service_type : String ='';
	lat : Number =0.00;
	lng : Number =0.00;
	
	is_book_order_api_call = 0;
	guest_login = 0;
	
	myCartDateTime: any;
	constructor(
	private _http: HttpService,private datePipe : DatePipe,
	private formBuilder: FormBuilder,
	public router: Router,
	private sharedService: ShareddataService,
	private notifyService : NotificationService,
	private eventBus: NgEventBus

	){
		var location_to_checkout =localStorage.getItem('location_to_checkout');
		if (location_to_checkout==='1') {
			localStorage.removeItem('location_to_checkout');
		} else {
			window.location.href="/";
		}
	}

  ngOnInit(): void {

	this.service_type=localStorage.getItem('selectedOrderService');
	if(this.service_type==='Delivery') {
		this.checkOutForm  =  this.formBuilder.group({
			first_name: ['', Validators.required],
			last_name: ['', Validators.required],
			
			card_number: ['', Validators.required],
			card_cvv: ['', Validators.required],
			postalCode: ['', Validators.required],
			state: ['', Validators.required],
			streetaddress: ['', Validators.required],
			city: ['', Validators.required],
			expiryMonth: ['', Validators.required],
			expiryYear: ['', Validators.required],
			//address: ['', Validators.required],
			deliveryinstruction: [''],
		});
		this.serviceTypeDeliveryProcessed();
	} else {
		$( "#different-billing" ).prop( "checked", true );

		this.checkOutForm  =  this.formBuilder.group({
			first_name: ['', Validators.required],
			last_name: ['', Validators.required],
			card_number: ['', Validators.required],
			card_cvv: ['', Validators.required],
			postalCode: ['', Validators.required],
			state: ['', Validators.required],
			streetaddress: ['', Validators.required],
			city: ['', Validators.required],
			expiryMonth: ['', Validators.required],
			expiryYear: ['', Validators.required],
		});  

	}
	
	this.orderDateTime();
	
	this.loadCarddiv();
	
	
	//added the month dropdown value
	this.monthDropDownValues=[];
	for(var i=12;i>=1;i--){
		this.monthDropDownValues.push(i);
	}
	
	//added the month dropdown value
	this.yearDropDownValues=[];
	var startYear=parseInt(this.thisYear);
	for(var j=startYear;j<startYear+10;j++){
		this.yearDropDownValues.push(j);
	}
	
	this.sharedService.sharedOrderDateTime.subscribe((response: any) => {
		this.orderDateTime();
	});	
	this.serverCalApiCall();
	this.eventBus.on('error:delivery').subscribe((meta:any) => {
		this.service_type = '';
		
    });
	this.eventBus.on('server:cal').subscribe((meta:any) => {
		if (localStorage.getItem('selectedOrderService') === 'Curbside' || localStorage.getItem('selectedOrderService') ==='Carry Out') {
			this.service_type = localStorage.getItem('selectedOrderService');
		}
		this.serverCalApiCall();
	});
	//Adding the user name 
	if(localStorage.getItem('user_detail')!=null) {
		this.user_detail= JSON.parse(localStorage.getItem('user_detail'));
		
		var name = this.user_detail.fullname;
		if (name!='') {
			name = name.split(' ');
			
			var firstName = '';
			var lastName = '';
			
			if (name.length==3) {
				firstName = name[0]+' '+name[1];
				lastName = name[2];
			}
			if (name.length==2) {
				firstName = name[0];
				lastName = name[1];
			}
			if (name.length==1) {
				firstName = name[0];
			}
			if (name.length>3) {
				firstName = name[0]+' '+name[1];
				lastName = name[2];
			}
			/* this.checkOutForm.patchValue (
				{
					first_name:firstName, 
					last_name:lastName, 
				}
			); */
		}
	   
	}
	if(localStorage.getItem('restaurant')!=null) {
		var restaurantlocal = JSON.parse(localStorage.getItem('restaurant'));
		this.showGiftCardLink =  restaurantlocal.enable_gift_card;
		this.enable_factor4 =  restaurantlocal.enable_factor4;

	}
	
	
  }
   
	 paymentViaSet (value:any) {
		if (value ==='giftcardf4') {
			this.checkOutForm.controls['expiryMonth'].clearValidators();
			this.checkOutForm.controls['expiryYear'].clearValidators();
		
			this.router.navigateByUrl('/gift-card-payment');
		} else {
			this.checkOutForm.controls['expiryMonth'].setValidators([Validators.required]);
			this.checkOutForm.controls['expiryYear'].setValidators([Validators.required]);
			this.router.navigateByUrl('/checkout');
		}
	    this.checkOutForm.controls['expiryMonth'].updateValueAndValidity();
	    this.checkOutForm.controls['expiryYear'].updateValueAndValidity();

		
		this.payment_via = value;
	 }
     serverCalApiCall () {
		
			
		var orderData=localStorage.getItem('orderData');
		this.serverCalucation = "0";
		if(orderData!=null){
			this.checkOutData=JSON.parse(orderData);
			this.cartTotalBalance=this.getTotalCartAmount(this.checkOutData);
			this.grandTotalwithTax=this.cartTotalBalance;
		}
		if(localStorage.getItem('francais_id')!=null){
			this.selectedFrancais=parseInt(localStorage.getItem('francais_id'));
		}
	
		var selectedOrderService=localStorage.getItem('selectedOrderService');
		this.selected_tip_percentage=localStorage.getItem('selected_tip_percentage');

		var promoData = JSON.parse(localStorage.getItem('promoData'));
		var isPromoApplied=localStorage.getItem('isPromoApplied');
		
		var iscouponApplied=localStorage.getItem('iscouponApplied');
		let couponData=JSON.parse(localStorage.getItem('couponData'));
		
		const server_cal_object = new FormData();

		server_cal_object.append( 'res_id', '49');
		server_cal_object.append( 'subtotal', this.cartTotalBalance);
		
		if (this.selectedFrancais>0) {
			server_cal_object.append( 'franchise_id', this.selectedFrancais);
		}
		if (this.selected_tip_percentage>0) {
			server_cal_object.append( 'selected_tip_percentage', this.selected_tip_percentage);
		}
		if (iscouponApplied!=null && iscouponApplied==='1' && couponData!=null) {
			console.log(couponData);
			var couponId = couponData.id;
			server_cal_object.append( 'couponid', couponId);
		}
		
		if (isPromoApplied!=null && isPromoApplied==='1' && promoData!=null) {
			var promoid = promoData.id;
			server_cal_object.append( 'promoid', promoid);
		}
		
		server_cal_object.append( 'service_type', selectedOrderService);
		this.discountAmount = 0.00;
		this.deliveryamount = 0.00;
		
		if (this.is_book_order_api_call==0) {
			$('.left-div-custom').hide();
			$('.completediv').show();	
		}
		
		this._http.postRequest('server_side_taxcal.php',server_cal_object).subscribe((data: any) => {
			
			
			if (data.error_type) {
				if (data.error_type==='other') {
					this.notifyService.showError(data.message, "Error ..!!");
					localStorage.removeItem('promoData');
					localStorage.removeItem('isPromoApplied');
					localStorage.removeItem('iscouponApplied');
					localStorage.removeItem('couponData');
					this.serverCalApiCall();
					return false;
				}
			}
			if (data.data.totalamount) {
				this.grandTotalwithTax = data.data.totalamount;
			}
			if (data.data.taxesdata) {
				this.francaisTax = data.data.taxesdata;
			}
			if (data.data.discountamount) {
				this.discountAmount = data.data.discountamount;
			}
			if (data.data.deliveryamount) {
				this.deliveryamount = data.data.deliveryamount;
			}
			if (data.data.tip_amount) {
				this.tip_amount = data.data.tip_amount;
			}
			if (data.data.is_surcharge_enabled==="1") {
				this.is_surcharge_enabled=data.data.is_surcharge_enabled;
				this.surcharge_amount=data.data.surcharge_amount;
				this.surcharge_label=data.data.surcharge_label;
			}
			this.serverCalucation = "1";
			
			if (this.is_book_order_api_call==0) {
				this.checkingloyalityreward();
				this.is_book_order_api_call = 1;
			}
			
			
		}); 
	}


   handleAddressChange(address) {
		this.lat=address.geometry.location.lat();
		this.lng=address.geometry.location.lng();

    }
	orderDateTime () {
		if(localStorage.getItem("orderDatetime")!=null){
			this.mytime=localStorage.getItem("orderDatetime");
			var orderTime = this.datePipe.transform(this.mytime, 'h:mm a');
			var orderDate = this.datePipe.transform(localStorage.getItem("orderDate"), 'EEEE, MMMM d');
			this.myCartDateTime=orderDate+' '+orderTime;
		}else{
			this.myCartDateTime=this.datePipe.transform(this.mytime, 'EEEE, MMMM d h:mm a');
		}
	}	
  
  
	getTotalCartAmount(cartData){
		var total_amount=0;
		for (var i=0;i<cartData.length;i++){
			total_amount=total_amount+cartData[i].ItemAmt;
		}
		return total_amount;		
	}
  
	loadCarddiv(){
		$('#card_number').validateCreditCard(function(result) {
		if(result.card_type){		
		if(result.card_type.name=='visa'){
			$('#card_number').attr('maxlength','16');
		}  
		if(result.card_type.name=='mastercard'){
			$('#card_number').attr('maxlength','16');
		}
		if(result.card_type.name=='amex'){
			$('#card_number').attr('maxlength','15');
		}
		}
			  
		if(result.card_type == null)
		{
		$('#card_number').removeClass();
		}
		else
		{
		$('#card_number').addClass(result.card_type.name);
		}

		if(!result.valid)
		{
		$('#card_number').removeClass("valid");
		}
		else
		{
		$('#card_number').addClass("valid");
		}
			
		});	

  }
	onEmailInputEvent(event: any) {
		$('#user_email_p').removeClass('has-error');
		var validEmail = this.validateEmail($('#user_email').val());
		if (validEmail==false) {
			$('#user_email_p').addClass('has-error');
		}
	}
  
	get formControls() { return this.checkOutForm.controls; }
	
	 cartItemDateTime(){
		var isvalid ='1';
		var orderData:any=localStorage.getItem('orderData');
		if(orderData!=null){
			orderData = JSON.parse(orderData);
			for (var i=0;i<orderData.length;i++) {
				
				const givenDate:any= new Date(orderData[i].date);
				const currentDate:any = new Date();
				
				const diffMs = currentDate - givenDate; // Difference in milliseconds
				const diffHours = diffMs / (1000 * 60 * 60); // Convert to hours
				const diffMinutes = diffMs / (1000 * 60); // Convert to minutes
				
				
				if (diffHours>4) {
				//if (diffMinutes>5) {
					alert("Order Timed Out - Order Lost, Please login and try again");
					localStorage.removeItem('isLogin');
					localStorage.removeItem('orderData');
					

					localStorage.removeItem('isLogin');
					localStorage.removeItem('user_detail');
					localStorage.removeItem('jwt_token');
					localStorage.removeItem('is_call');
					var root = this;
					isvalid ='0';
					setTimeout(() => {
					  this.router.navigateByUrl('/login');
					}, 500);
			
					//window.location.href='/login';
				}
				
			}
			
		}
		return isvalid;
	  }
    
    checkOutProccess(){
		this.cartItemDateTime();
		
		$('#user_email_p').removeClass('has-error');
		if ( this.user_detail.guest_login) {
			
			var validEmail = this.validateEmail($('#user_email').val());
			
			if (validEmail==false) {
				$('#user_email_p').addClass('has-error');
			}
		}
			
		if (this.serverCalucation==='1') {
			this.cardErrorApiCall='';
			this.isSubmitted = true;
			if(this.checkOutForm.invalid){
			  return;
			}
			
			if ( this.user_detail.guest_login) {
				if ($('#user_email').val()==="") {
					this.cardErrorApiCall ="Please enter the email.";
					return ;
				}
				
				var validEmail = this.validateEmail($('#user_email').val());
				console.log(validEmail);
				if (validEmail==false) {
					$('#user_email_p').addClass('has-error');
					this.cardErrorApiCall ="Invalid email.";
					return ;
				}
				
			}
	
			this.checkOutSpin=1;
			var userData=JSON.parse(localStorage.getItem('user_detail'));
			const doTranscation = new FormData();
			this.bookOrder();
		}
	}
	
	validateEmail(email) {
	  // Regular expression to check if the email is valid
	  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	  
	  return regex.test(email);
	}

    bookOrder(){
	
	
	var different_billing =  $('#different-billing').prop('checked');
	
	var userData=JSON.parse(localStorage.getItem('user_detail'));
	var franchise_id=localStorage.getItem('francais_id');
	var promoData=JSON.parse(localStorage.getItem('promoData'));
	var couponData=JSON.parse(localStorage.getItem('couponData'));
	var orderData=JSON.parse(localStorage.getItem('orderData'));
	orderData={
		'Order':orderData
	};
	
	var sales_tax1_amount='';
	var sales_tax1_per='';
	var sales_tax2_amount='';
	var sales_tax2_per='';
	if(this.francaisTax[0]){
		if (typeof this.francaisTax[0].amount === 'string'){
			sales_tax1_amount=parseFloat(this.francaisTax[0].amount).toFixed(2);
		} else {
			sales_tax1_amount=this.francaisTax[0].amount.toFixed(2);
		}
		sales_tax1_per=this.francaisTax[0].sales_tax_percentage;

	}
	if(this.francaisTax[1]){
		if (typeof this.francaisTax[1].amount === 'string'){
			sales_tax2_amount=parseFloat(this.francaisTax[1].amount).toFixed(2);
		} else {
			sales_tax2_amount=this.francaisTax[1].amount.toFixed(2);
		}
		sales_tax2_per=this.francaisTax[1].sales_tax_percentage;
	}
	
	const bookOrderdata = new FormData();
	//Added the sales text filed
	bookOrderdata.append( 'sales_tax1_amount', sales_tax1_amount);
	bookOrderdata.append( 'sales_tax2_amount', sales_tax2_amount);
	bookOrderdata.append( 'sales_tax1_percentage', sales_tax1_per);
	bookOrderdata.append( 'sales_tax2_percentage', sales_tax2_per);
	bookOrderdata.append( 'delivery_fee', this.deliveryamount);
	
	
	bookOrderdata.append( 'user_id', userData.id );
	bookOrderdata.append( 'res_id', '49' );
	bookOrderdata.append( 'franchise_id', franchise_id );
	var notes='';
	
	if(this.service_type==="Delivery") {
		notes=this.checkOutForm.value.deliveryinstruction;
	}
	
	if(this.service_type==="Delivery" && different_billing==true) {
		
		if(localStorage.getItem('deliveryAddress')!=null){
			var deliveryAddress=JSON.parse(localStorage.getItem('deliveryAddress'));
			this.deliveryAddressSaved = deliveryAddress;
			for (var i=0;i<deliveryAddress.length;i++) {
				 if(deliveryAddress[i].lat && deliveryAddress[i].lat!='') {
				  bookOrderdata.append( 'lat', deliveryAddress[i].lat);
					
				 } if(deliveryAddress[i].lng && deliveryAddress[i].lng!='') {
				  
					bookOrderdata.append( 'long', deliveryAddress[i].lng );

				 } if(deliveryAddress[i].fulladdress) {
					
					bookOrderdata.append( 'address', deliveryAddress[i].fulladdress );
					bookOrderdata.append( 'street', deliveryAddress[i].fulladdress );

				}if(deliveryAddress[i].city) {
					
					bookOrderdata.append( 'city', deliveryAddress[i].city );
					
				}if(deliveryAddress[i].state) {
					
					bookOrderdata.append( 'state', deliveryAddress[i].state );
				}
			}
		}
	} else {
		var lat= this.lat.toString();
		var lng= this.lng.toString();
	
		bookOrderdata.append( 'email', $('#user_email').val() );
		bookOrderdata.append( 'address', this.checkOutForm.value.streetaddress );
		bookOrderdata.append( 'city', this.checkOutForm.value.city);
		bookOrderdata.append( 'lat', lat);
		bookOrderdata.append( 'long', lng);
		bookOrderdata.append( 'state', this.checkOutForm.value.state);
		bookOrderdata.append( 'street', this.checkOutForm.value.streetaddress);
	}
	
	var is_future = "0";
	var orderDate= this.datePipe.transform(new Date(), 'yyyy-MM-dd H:mm:ss')
	
	if (localStorage.getItem('isOrderDateTimeChange')==='1') {
		var orderTime = this.datePipe.transform(localStorage.getItem("orderDatetime"), 'H:mm:ss');
		var orderDateLocalStrg = this.datePipe.transform(localStorage.getItem("orderDate"), 'yyyy-MM-dd');
		orderDate=orderDateLocalStrg+' '+orderTime;
		var compareOrderDateTime = new Date(orderDate);
		console.log(this.datePipe.transform(new Date(), 'yyyy-MM-dd H:mm'));
		console.log(this.datePipe.transform(compareOrderDateTime, 'yyyy-MM-dd H:mm'));
		
		/* if (this.datePipe.transform(new Date(), 'yyyy-MM-dd H:mm')<this.datePipe.transform(compareOrderDateTime, 'yyyy-MM-dd H:mm')) {
			is_future = "1"
		} */
		if (new Date()<compareOrderDateTime) {
			is_future = "1"
		}
	} 

	bookOrderdata.append( 'is_future', is_future);
	bookOrderdata.append( 'order_date', orderDate);
	
	bookOrderdata.append( 'postal_code', this.checkOutForm.value.postalCode);
	bookOrderdata.append( 'zip_code', '');
	
	bookOrderdata.append( 'food_desc', JSON.stringify(orderData));
	bookOrderdata.append( 'notes', notes);
	bookOrderdata.append( 'promo_code_id', '');
	bookOrderdata.append( 'service_type', localStorage.getItem('selectedOrderService'));
	bookOrderdata.append( 'tip', this.tip_amount);
	bookOrderdata.append( 'tip_percentage', this.selected_tip_percentage);
	bookOrderdata.append( 'discount', '0.00');
	//bookOrderdata.append( 'payment_id', this.payment_id);
	bookOrderdata.append( 'sub_total', this.cartTotalBalance.toFixed(2));
	bookOrderdata.append( 'country', '');
	bookOrderdata.append( 'apartment', '');
	
	/* Start parms for card */
	//bookOrderdata.append('id', userData.id);
	bookOrderdata.append('first_name', this.checkOutForm.value.first_name);
	bookOrderdata.append('last_name', this.checkOutForm.value.last_name);
	bookOrderdata.append('ccnumber', this.checkOutForm.value.card_number);
	bookOrderdata.append('ccexp', this.checkOutForm.value.expiryMonth+'-'+this.checkOutForm.value.expiryYear);
	bookOrderdata.append('cvv',this.checkOutForm.value.card_cvv);
	bookOrderdata.append('transaction_type', 'do_transaction');
	bookOrderdata.append('billing_address', this.checkOutForm.value.streetaddress);
	bookOrderdata.append('billing_city', this.checkOutForm.value.city);
	bookOrderdata.append('billing_state', this.checkOutForm.value.state);
	bookOrderdata.append('billing_zip', this.checkOutForm.value.postalCode);
	/* End parms for Card payment */
	
	
	
	bookOrderdata.append( 'card_name', '');
	bookOrderdata.append( 'is_paid', '1');
	bookOrderdata.append( 'os', 'website');
	bookOrderdata.append( 'surcharge_label', this.surcharge_label);
	bookOrderdata.append( 'surcharge_amount', this.surcharge_amount);
	
	bookOrderdata.append( 'discount_price', parseFloat(this.discountAmount).toFixed(2));
	
	if(promoData!=null) {
		bookOrderdata.append( 'promo_code_id', promoData.id);
		bookOrderdata.append( 'discount_type', 'promo');
	}
	
	if(couponData!=null) {
		bookOrderdata.append( 'promo_code_id', couponData.id);
		bookOrderdata.append( 'discount_type', 'coupon');
	}
	var apiName = "mullti_pay_bookorder_and_transaction.php";
	//var apiName = "bookorder_and_transaction.php";
	
	
	var loyalityapply = localStorage.getItem('loyalityapply');
	
	if (loyalityapply==='1' && parseFloat(this.loyalityrewardamount)>=parseFloat(this.grandTotalwithTax)) {
		$('.left-div-custom').hide();
		$('.completediv').show();
				
		bookOrderdata.append('payment_type', 'loyalty');
		bookOrderdata.append( 'total_price', '0.00');
		bookOrderdata.append('amount', '0.00');
	}else if (loyalityapply==='1' && parseFloat(this.loyalityrewardamount)<=parseFloat(this.grandTotalwithTax)) {
		console.log(this.grandTotalwithTax, 'Grand Total');
		var finaeamtn:any = parseFloat(this.grandTotalwithTax)-parseFloat(this.loyalityrewardamount);
		bookOrderdata.append('payment_type', this.payment_via);
		bookOrderdata.append( 'total_price', finaeamtn.toFixed(2));
		bookOrderdata.append( 'amount', finaeamtn.toFixed(2));
	} else {
		bookOrderdata.append('payment_type', this.payment_via);
		bookOrderdata.append( 'total_price', this.grandTotalwithTax);
		bookOrderdata.append( 'amount', this.grandTotalwithTax);
	}
	if (this.enable_factor4==='1') {
		//apiName = "bookorder_and_transaction_withloyalty.php";
	
	}
	if (loyalityapply==='1' || loyalityapply==='0') {
		if (this.loyalityrewardamount==0) {
			bookOrderdata.append( 'loyalty_amount', '0.00');
		} else {
		bookOrderdata.append( 'loyalty_amount', this.loyalityrewardamount);
		}
	}
	bookOrderdata.append( 'loyalty_account_id', localStorage.getItem('account_number'));
	bookOrderdata.append( 'loyalty_pin', localStorage.getItem('loyalty_pin'));	
	
	//hanling the Gift card logic
	var giftcard_apply = localStorage.getItem('giftcard_apply');
	if (giftcard_apply==='1') {
		var giftcard_amount = parseFloat(localStorage.getItem('giftcard_amount'));
		


		if (giftcard_amount>0 && giftcard_amount!=null) {
			bookOrderdata.append( 'giftcard_pin', localStorage.getItem('giftcard_pin'));
			bookOrderdata.append( 'giftcard_account_id', localStorage.getItem('giftcard_account_id'));	
			bookOrderdata.append( 'giftcard_amount',giftcard_amount.toFixed(2));
			
			
			if (giftcard_amount>=this.grandTotalwithTax) {
				bookOrderdata.append('payment_type', "giftCard");
				$('.left-div-custom').hide();
				$('.completediv').show();
			}
			var finaeamtn:any = parseFloat(this.grandTotalwithTax)-giftcard_amount;
			var giftCardloyality:any =  giftcard_amount;
			if (this.loyalityrewardamount!=null && this.loyalityrewardamount>0) {
				
				finaeamtn = parseFloat(finaeamtn.toFixed(2))-parseFloat(this.loyalityrewardamount);
				
				giftCardloyality = giftCardloyality+parseFloat(this.loyalityrewardamount)
				giftCardloyality = giftCardloyality.toFixed(2);
			}
			
			
			if (giftCardloyality>=this.grandTotalwithTax) {
				bookOrderdata.append('payment_type', "giftCard");
				$('.left-div-custom').hide();
				$('.completediv').show();
			}
			
			bookOrderdata.append( 'total_price', finaeamtn.toFixed(2));
			bookOrderdata.append( 'amount', finaeamtn.toFixed(2));
		
		}
	}
	
	this.checkOutSpin = 1;
	$('.left-div-custom').hide();
			
	this._http.postRequest(apiName ,bookOrderdata).subscribe((reponse : any)=>{
        this.checkOutSpin=0;
		
		this.bookOrderApiMessage='';
		if(reponse.success==="1"){
			this.bookOrderApiMessage="Your order has been placed successfully";
			this.bookOrderResponse=reponse.order_details[0];
			$('#bookOrderSuccesModal').modal({
				backdrop: 'static',
				keyboard: false
			});
			$('#bookOrderSuccesModal').modal('show');
			
			localStorage.removeItem('url_store_id');
			localStorage.removeItem('loyalityapply');
			localStorage.removeItem('account_number');
			localStorage.removeItem('loyalty_pin');
			localStorage.removeItem('loyalityrewardamount');
			
			localStorage.removeItem('orderData');
			localStorage.removeItem('francais_id');
			
			localStorage.removeItem('promoData');
			localStorage.removeItem('isPromoApplied');
			localStorage.removeItem('couponData');
			localStorage.removeItem('iscouponApplied');
			
			localStorage.removeItem('selectedOrderService');
			localStorage.removeItem('orderDatetime');
			localStorage.removeItem('orderDate');
			localStorage.removeItem('isOrderDateTimeChange');
			localStorage.removeItem('selected_tip_percentage');
			localStorage.removeItem('deliveryAddress');
			
			localStorage.removeItem('giftcard_pin');
			localStorage.removeItem('giftcard_account_id');
			localStorage.removeItem('giftcard_amount');
			localStorage.removeItem('giftcard_apply');
			if (this.user_detail.id==1) {
				localStorage.removeItem('isLogin');
				localStorage.removeItem('user_detail');
			}
			
			
			
		} else {
			if (reponse.error_type) {
				$('.left-div-custom').show();
				$('.completediv').hide();


				if (reponse.error_type==='loyalty') {
					localStorage.removeItem('loyalityapply');
					localStorage.removeItem('account_number');
					localStorage.removeItem('loyalty_pin');
					localStorage.removeItem('loyalityrewardamount');
					this.checkingloyalityreward();
					this.serverCalApiCall();
				}
				
				if (reponse.error_type==='giftcard' || reponse.error_type==='creditcard') {
					localStorage.removeItem('loyalityapply');
					localStorage.removeItem('account_number');
					localStorage.removeItem('loyalty_pin');
					localStorage.removeItem('loyalityrewardamount');
					
					localStorage.removeItem('giftcard_pin');
					localStorage.removeItem('giftcard_account_id');
					localStorage.removeItem('giftcard_amount');
					localStorage.removeItem('giftcard_apply');
					
					this.checkingloyalityreward();
					this.serverCalApiCall();
				}
			}
			this.cardErrorApiCall=reponse.message;
			this.checkOutSpin=0;
		}
		
		
	  }) 
	  
  }
	closeordersuccess(){
		this.router.navigateByUrl('/');
		window.location.href='/';
	}
  
	
	
	
	differentBillingChange(event) {
		if (event.currentTarget.checked) {
			this.lat=0;
			this.lng=0;
			this.checkOutForm.patchValue({streetaddress:''});
			this.checkOutForm.patchValue({city:''});
			this.checkOutForm.patchValue({state:''});
		  } else {
			this.serviceTypeDeliveryProcessed();
		  }
	}
	serviceTypeDeliveryProcessed () {
		if(localStorage.getItem('deliveryAddress')!=null){
			var deliveryAddress=JSON.parse(localStorage.getItem('deliveryAddress'));
			this.deliveryAddressSaved = deliveryAddress;
			for (var i=0;i<deliveryAddress.length;i++) {
				 if(deliveryAddress[i].lat && deliveryAddress[i].lat!='') {
				    this.lat=deliveryAddress[i].lat;
				 } if(deliveryAddress[i].lng && deliveryAddress[i].lng!='') {
				    this.lng=deliveryAddress[i].lng;
				 } if(deliveryAddress[i].fulladdress) {
					this.checkOutForm.patchValue({streetaddress:deliveryAddress[i].fulladdress});
				}if(deliveryAddress[i].city) {
					this.checkOutForm.patchValue({city:deliveryAddress[i].city});
				}if(deliveryAddress[i].state) {
					this.checkOutForm.patchValue({state:deliveryAddress[i].state});
				}
			}
		}
	}
		
	pizaToppingPriceCart (cartData:any, addOn:any)
	{
		var topingamt = addOn.pizaextra_price;
		topingamt = topingamt*cartData.ItemQty;
		return topingamt.toFixed(2);
	}
	
	checkingloyalityreward () {
	
		var account_number = localStorage.getItem('account_number');
		this.loyalityrewardamount = localStorage.getItem('loyalityrewardamount');
		this.giftcard_amount = localStorage.getItem('giftcard_amount');
		var giftcard_apply = localStorage.getItem('giftcard_apply');
		var loyalityapply = localStorage.getItem('loyalityapply');
		var giftcard_apply = localStorage.getItem('giftcard_apply');
		
		var totalAmount:any = 0;
		if (this.loyalityrewardamount>0 && this.loyalityrewardamount!=null) {
			this.loyalityrewardamount = parseFloat(this.loyalityrewardamount).toFixed(2);
			
			totalAmount = parseFloat(this.loyalityrewardamount);
		}
		if (this.giftcard_amount>0 && this.giftcard_amount!=null) {
			totalAmount = totalAmount+parseFloat(this.giftcard_amount);
		}
		totalAmount = totalAmount.toFixed(2);
		totalAmount = parseFloat(totalAmount);
	
		if ((loyalityapply==='1' || giftcard_apply==='1' ) && totalAmount>=parseFloat(this.grandTotalwithTax)) {
			this.showCompleteOrderButton = '1';
			$('.left-div-custom').hide();
			$('.completediv').show();
		
			
			this.checkOutSpin = 1;
			
			this.bookOrder();

		} else {
			this.showCompleteOrderButton = '0';
			
			$('.left-div-custom').show();
		}
		
		if (this.loyalityrewardamount==null) {
			this.loyalityrewardamount = 0;
		}
		
		if (this.giftcard_amount==null) {
			this.giftcard_amount = 0;
		}
	}
}	
